/**
 * Social sharing buttons script
 */
class NatAug_Slideshow {
    constructor() {
        if(!$('.home .slideshow').length) {
            return;
        }

        this.init();
    }

    init () {
        // UI
        this.UI = {};
        this.UI.wrapper = $('.home .slideshow');
        this.UI.dots = this.UI.wrapper.find('.slideshow-nav-item');
        this.UI.items = this.UI.wrapper.find('.slideshow-item');

        // State
        this.state = {};
        this.state.interval = 10000;
        this.state.skipNextFrame = false;

        // Init events
        this.initEvents();

        // Run
        setTimeout(() => {
            this.autoAnimate();
        }, this.state.interval);
    }

    initEvents () {
        for (let i = 0; i < this.UI.dots.length; i++) {
            this.UI.dots.eq(i).on('click', e => {
                e.preventDefault();
                this.UI.wrapper.attr('data-current', parseInt(i + 1, 10));
                this.state.skipNextFrame = true;
            });
        }
    }

    getCurrentItem () {
        return parseInt(this.UI.wrapper.attr('data-current'), 10);
    }

    setCurrentItem (newValue) {
        this.UI.wrapper.attr('data-current', (newValue).toString());
    }

    autoAnimate () {
        if (this.state.skipNextFrame) {
            this.state.skipNextFrame = false;
        } else {
            let currentSlide = this.getCurrentItem();

            if (currentSlide < this.UI.items.length) {
                currentSlide++;
            } else {
                currentSlide = 1;
            }

            this.setCurrentItem(currentSlide);
        }

        setTimeout(() => {
            this.autoAnimate();
        }, this.state.interval);
    }
}
